import { useQuery } from "@tanstack/react-query";
import get from "lodash/get";
import { useMemo } from "react";
import { apiRequest } from "shared/api/apiRequest";
import { getSocietyDashboardIdContract } from "shared/api/contracts/society/societyId/dashboards/dashboardId";
import Spinner from "shared/components/common/Spinner";
import { type ChartDataType } from "shared/components/dashboard/dashboardMapper";
import PillarTable from "shared/components/pillar-table/PillarTable";
import { useSocietySession } from "shared/context/SocietySessionContext";

const ShortTableType = ({ dashboardId }: { dashboardId: number }) => {
  const { societyId } = useSocietySession();
  const { data, isLoading } = useQuery({
    queryKey: ["dashboardModule", dashboardId],
    queryFn: async () =>
      apiRequest({
        contract: getSocietyDashboardIdContract,
        inputs: {
          params: {
            societyId,
            dashboardId: dashboardId,
          },
        },
      }),
    refetchOnWindowFocus: false,
  });

  const tableData = useMemo(() => {
    return {
      data: (data?.data ?? []) as ChartDataType,
    };
  }, [data]);
  const displayColumns = useMemo(() => {
    const dataValues = tableData.data;
    const columnNameSet = new Set<string>();
    dataValues.forEach((v) => Object.keys(v).map((k) => columnNameSet.add(k)));
    return Array.from(columnNameSet.values());
  }, [tableData]);

  if (isLoading) {
    return (
      <div className="col-span-6 flex h-50 w-full items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (!data) {
    return <></>;
  }

  return (
    <div className="max-h-50">
      <div className="text-center text-base">
        <a href="#" className="mb-2 inline-block text-xl font-semibold">
          {data.dashboardModule.title}
        </a>
      </div>
      <PillarTable
        className="flex-1 w-full"
        pillarTableContext={{
          tableRowResults: tableData.data,
        }}
      >
        {displayColumns.map((name) => {
          return (
            <PillarTable.Column key={name} heading={name}>
              {(row) => get(row, name)}
            </PillarTable.Column>
          );
        })}
      </PillarTable>
    </div>
  );
};

export default ShortTableType;
